import { StyleSheet } from 'react-native';
import config from '../../lib/config';

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#F5F5F5',
    flex: 1,
  },
  header: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    flex: 2,
    alignContent: 'center',
  },
  fieldContent: {
    marginHorizontal: 16,
    backgroundColor: '#ffffff',
    flexDirection: 'row',
    paddingHorizontal: 12,
    paddingVertical: 6,
    marginBottom: 3,
    alignItems: 'center',
  },
  titleFieldWrapper: {
    flex: 1,
  },
  titleField: {
    fontWeight: '600',
    fontSize: 16,
    color: config.theme.advert.headingTextColor,
    marginBottom: 4,
  },
  titleContent: {
    fontWeight: 'normal',
    fontSize: 12,
    marginTop: 2,
    color: config.theme.headingTextColor,
    marginBottom: 8,
  },
  iconField: {
    alignSelf: 'center',
  },
  iconFieldStyle: {
    color: config.theme.advert.subSectionHeadingTextColor,
  },
  emptyPlaceholder: {
    margin: 16,
    justifyContent: 'center',
  },
  emptyText: {
    color: config.theme.headingTextColor,
    fontSize: 16,
    textAlign: 'center',
  },
  disabledText: {
    fontWeight: 'bold',
  },
  headerImage: {
    width: 150,
    height: 150,
    backgroundColor: 'transparent',
    alignSelf: 'center',
    marginBottom: 50,
  },
  titleFlatList: {
    fontWeight: '500',
    color: config.theme.advert.headingTextColor,
    marginBottom: 8,
    marginLeft: 16,
  },
  viewAll: {
    fontWeight: '500',
    color: config.theme.advert.headingTextColor,
    marginTop: 8,
    marginLeft: 16,
    textDecorationLine: 'underline',
  },
  circleIcon: {
    borderRadius: 30,
    borderWidth: 0.5,
    width: 60,
    height: 60,
    alignItems: 'center',
    justifyContent: 'center',
    borderColor: '#5D5D5D',
    alignSelf: 'center',
    marginTop: 80,
  },
  backToLesS: {
    alignSelf: 'flex-start',
    marginLeft: 16,
  },
  modalStyle: {
    justifyContent: 'flex-end',
    margin: 0,
    marginTop: 40,
  },
  modalContent: {
    flex: 1,
    backgroundColor: 'white',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    paddingHorizontal: 20,
    paddingTop: 16,
  },
  modalBody: {
    padding: 16,
  },
  modalTopClose: {
    alignSelf: 'flex-start',
  },
  modalTitle: {
    color: '#5D5D5D',
    fontSize: config.theme.headingFontSize,
    fontWeight: '700',
    textAlign: 'center',
    marginVertical: 20,
  },
  serviceLine: {
    color: '#5D5D5D',
  },
  marginServiceLine: {
    marginTop: 20,
  },
  loaderContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    flex: 1,
    // height: 50,
    // width: 50,
    backgroundColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 20,
    zIndex: 10000,
  },
  headerRequest: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  description: {
    marginTop: 20,
    marginBottom: 4,
    marginLeft: 0,
  },
  checkbox: {
    backgroundColor: 'white',
    borderWidth: 0,
    paddingHorizontal: 0,
    marginLeft: 0,
  },
  checkboxTitle: {
    color: '#5d5d5d',
  },
  checkboxContainer: {
    backgroundColor: 'white',
    marginHorizontal: 0,
    paddingHorizontal: 0,
  },
  circleClose: {
    width: 40,
    height: 40,
    borderRadius: 20,
    borderColor: '#5d5d5d',
    borderWidth: 1,
    justifyContent: 'center',
    alignContent: 'center',
    alignSelf: 'center',
    marginTop: 30,
  },
  circleBototm: {
    marginBottom: 20,
  },
  circleSuccess: {
    marginTop: 50,
  },
  successMessage: {
    color: '#5d5d5d',
  },
  successTitle: {
    marginTop: 60,
  },
  bottomTitle: {
    fontWeight: '500',
    color: config.theme.advert.headingTextColor,
    marginBottom: 8,
    marginLeft: 16,
    textAlign: 'center',
    marginTop: 8,
  },
  dropDownStyle: {
    backgroundColor: '#fafafa',
  },
  dropdownItemStyle: {
    justifyContent: 'flex-start',
  },
  dropDownContainer: {
    height: 40,
  },
  error: {
    color: 'red',
    fontSize: 12,
    margin: 5,
  },
  topBack: {
    alignSelf: 'flex-start',
    margin: 16,
  },
  iconButtonContainer: {
    width: 50,
    height: 50,
  },
  offscreenLeft: {
    left: -10000,
  },
  addImage: {
    width: 30,
    height: 30,
  },
  descriptionContainer: {
    paddingHorizontal: 0,
  },
  callCenterHeading: {
    color: '#5D5D5D',
    fontSize: config.theme.headingFontSize,
    fontWeight: '500',
    textAlign: 'center',
    marginVertical: 10,
  },
  callCenterButton: {
    marginBottom: 20,
  },
});

export default styles;
